<template>
  <Modal title="评价" v-model="modal2" class-name="vertical-center-modal" width="800" @on-visible-change="closeFun"
    @on-ok="handleSave">
    <Form :model="form" :label-width="160" style="height:60px">
      <FormItem label="您对本次服务的评价：">
        <RadioGroup v-model="form.EvaluateCode">
          <Radio :label="i.SystemInfoCode" v-for="i in radioOption">{{i.SystemInfoName}}</Radio>
        </RadioGroup>
      </FormItem>
    </Form>
  </Modal>
</template>

<script>
import { UpdateEvaluate ,GetEvaluateType } from '@api'
export default {
  name: 'reservation',
  data() {
    return {
      form: {
        EvaluateCode: "",
        SID: ""
      },
      formItems: [],
      item: {},
      modal2: false,
      radioOption: []
    }
  },
  computed: {
    minHeight() {
      return { 'min-height': `${this.$store.state.init.offsetHeight - 251}px` }
    }
  },
  watch: {

  },
  async created() {
    this.radioOption = (await GetEvaluateType()).data
  },
  methods: {
    jump() {
      if (this.$route.name === 'search') {
        window.location.reload()
      } else {
        this.$router.push({
          path: 'search',
          params: { reload: true }
        })
      }
    },
    open(SubscribeNo) {
      this.modal2 = true;
      this.form.SID = SubscribeNo;
    },
    async handleSave() {
      const res =await UpdateEvaluate(this.form);
      this.jump()
    },
    closeFun(val) {
      return
      if (!val) {
        this.jump()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ivu-radio-wrapper {
  margin-right: 40px
}
</style>
